module.exports = __webpack_public_path__ + "static/media/omg_logo_big.2e2f53a3.png";